import type { Directive } from 'vue'

import {
  attachScrollFade,
  type ScrollFadeHandle,
  type ScrollFadeOptions,
} from '../../lib/scroll-fade'

const handles = new WeakMap<HTMLElement, ScrollFadeHandle>()

function sameOptions(
  a: ScrollFadeOptions | null | undefined,
  b: ScrollFadeOptions | null | undefined,
): boolean {
  return a?.axis === b?.axis && a?.anchor === b?.anchor && a?.endInset === b?.endInset
}

/** Fades the edges of a scroll area that hide content; takes optional `ScrollFadeOptions` as its value. */
export const vScrollFade: Directive<HTMLElement, ScrollFadeOptions | undefined> = {
  mounted(el, binding) {
    handles.set(el, attachScrollFade(el, binding.value ?? {}))
  },
  updated(el, binding) {
    if (sameOptions(binding.value, binding.oldValue)) return
    handles.get(el)?.update(binding.value ?? {})
  },
  beforeUnmount(el) {
    handles.get(el)?.detach()
    handles.delete(el)
  },
}
